/**
 * @(#)2019/7/1.
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import "./index.less";
import Icon from "../YxText/Icon";
import config from "../../config";
import React, { Component } from "react";
import { l } from "../../config/language";
import { get, set, merge, cloneDeep, yxBtnProps } from "../../utils";
import { Button, Icon as AntdIcon } from "antd";
import { YxComponent, Route, Connection } from "../YxComponent";
/**
 * button组件
 * @param  {ReactNode} children 按钮子节点，可以是jsx，可以是其他数据
 * @param {any} iconfont 是否显示icon
 * @param  {string} type 按钮类型  （primary/secondary） 主要/次要(默认)   ,   同时还支持antd属性， 请参考其api
 * @param  {object} styleParam 存放所有的样式风格类参数
 * @param  {string} styleParam.size //样式风格-大小 可以不填，或small
 * @param  {string} styleParam.type //样式风格-类型   primary/secondary/dashed  主要/次要(默认) /虚线
 * @param  {object}  inputParams 输入框的参数
 * @return {ReactNode}   返回渲染后的组件
 */
let defaul = () => {
  return {
    type: "secondary",
    size: get(config, "button.size", "default"),
    styleParam: {
      size: "primary", //样式风格-大小
      type: "", //样式风格-类型
    },
    icon: null,
    dropDown: false, // 是否为收起形态按钮
  };
};
@Connection(defaul)
class YxButton extends YxComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }
  // 已插入真实DOM
  componentDidMount() {}

  renderIcon = () => {
    const dropDown = get(this.props, "dropDown", false);
    if (dropDown == false) {
      return null;
    } else {
      const iconParam = get(this.props, "iconParam", {});
      const param = {
        type: "iconxialazhanshi",
        iconfont: true,
      };
      return <Icon {...merge(param, iconParam)} />;
    }
  };

  classProcess = (tmpProps) => {
    let classParam = {
      yx_yxButton: "",
      yx_yxButton_: "styleParam.type",
      yx_yxButton_size_: "styleParam.size",
      yx_button_icon: [],
    };
    let iconClass = "";
    if (get(tmpProps, "dropDown", false) === true) {
      iconClass = "yx_button_dropDown";
    }
    tmpProps.className =
      this.styleParamClassName(tmpProps, classParam) + ` ${iconClass}`;
    return tmpProps;
  };

  render() {
    let tmpProps = cloneDeep(this.props);
    tmpProps.styleParam = merge(
      get(tmpProps, "styleParam", {}),
      get(tmpProps, "inputParams", "")
    );
    const text = get(this.props, ["children", "text"], l("YxButton.t"));
    //默认使用外层的参数，为了和antd默认保持一致
    if (!get(tmpProps, "styleParam.size", false)) {
      tmpProps.styleParam.size = tmpProps.size;
    }
    if (!get(tmpProps, "styleParam.type", false)) {
      tmpProps.styleParam.type = tmpProps.type;
    }
    if (get(tmpProps, "inputParams.icon", false)) {
      tmpProps.icon = get(tmpProps, "inputParams.icon");
    }
    tmpProps = this.classProcess(tmpProps);
    return (
      <Button {...yxBtnProps(tmpProps)}>
        {text}
        {this.renderIcon()}
      </Button>
    );
  }
}

export default YxButton;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxButton/YxButton.js